import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserAction } from '../store/user.action';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {

    constructor(private store: Store) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
            .pipe(
                catchError((err: any) => {

                    if (req.url !== '/api/user/login' && err instanceof HttpErrorResponse && err.status === 401) {
                        this.store.dispatch(new UserAction.Unauthorized());
                    }
                    return throwError(err);
                })
            );
    }
}
